import axios from "axios";

// Reutiliza la base de la URL API de tu entorno
const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

/* =========================================================================
   Obtiene el resumen del Dashboard
========================================================================= */

/**
 * Obtiene el resumen del dashboard para el año/mes indicado (por defecto, el actual).
 * @returns {Promise<object>}
 * {
 *   anio, mes,
 *   cotizacionesMes: number,
 *   facturasMes: number,
 *   totalFacturado: number,
 *   cotizacionesPorFacturar: number,
 *   cotizacionesCerradasMes: number,
 *   cotizacionesSinCerrarMes: number
 * }
 */
export async function obtenerResumenDashboard(anio, mes) {
  const API_URL = `${API_BASE}/api/dashboard/resumen`;
  const empresaId = Number(localStorage.getItem("empresaId") || 0);

  try {
    // ⚠️ mes=0 significa "Todos" (acumulado del año) y es un valor válido —
    // usar ?? en vez de || para no perderlo (0 || undefined => undefined).
    const response = await axios.get(API_URL, {
      params: { anio: anio ?? undefined, mes: mes ?? undefined, empresaId },
    });
    return response.data;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      console.error(
        "Error al obtener resumen del dashboard (Axios):",
        e.response?.data || e.message,
      );

      throw new Error(
        `Error al cargar el dashboard: ${e.response?.statusText || e.message}`,
      );
    }

    console.error("Error desconocido al obtener dashboard:", e);
    throw e;
  }
}

// Facturación de los 12 meses del año indicado (por defecto, el actual)
export async function obtenerFacturacionMensual(anio) {
  const API_URL = `${API_BASE}/api/dashboard/facturacion-mensual`;
  const empresaId = Number(localStorage.getItem("empresaId") || 0);

  try {
    const response = await axios.get(API_URL, {
      params: { anio: anio || undefined, empresaId },
    });
    return response.data; // { anio, anios, data: [{ mes, total }] }
  } catch (e) {
    throw new Error("Error al cargar gráfica de facturación");
  }
}
